import { render, staticRenderFns } from "./SectionsHome.vue?vue&type=template&id=bb5aa57a&scoped=true"
import script from "./SectionsHome.vue?vue&type=script&lang=js"
export * from "./SectionsHome.vue?vue&type=script&lang=js"
import style0 from "./SectionsHome.vue?vue&type=style&index=0&id=bb5aa57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5aa57a",
  null
  
)

export default component.exports